import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/laravel-mix/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-14.use[3]!../../node_modules/sass-resources-loader/lib/loader.js??clonedRuleSet-14.use[4]!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DialogContent.vue?vue&type=style&index=0&id=1997adbb&prod&lang=scss&scoped=true&";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};